import {MarkdownViewer} from '@/components/Markdown'
import Code from './Code.jsx'
import CustomElement from './CustomElement.jsx'

export const Markdown = (props) => {
    const components = {
        code({children, className, node, ...props}) {
            const match = /language-(\w+)/.exec(className || '')

            if (match) {
                if ('json' === match[1]) {
                    return (
                        <CustomElement {...props}>
                            {children}
                        </CustomElement>
                    )
                }
                else {
                    return (
                        <Code
                            language={match[1]}
                            {...props}
                        >
                            {children}
                        </Code>
                    )
                }
            }
            else {
                return (
                    <code
                        className={className}
                        {...props}
                    >
                        {children}
                    </code>
                )
            }
        },
    }

    return (
        <MarkdownViewer
            components={components}
            {...props}
        />
    )
}
